
import React, { Component } from "react";

import { Spin, Button, Tooltip } from 'antd';

import WidgetPagination from './WidgetPagination';

import '../css/widget/widget.list.vertical.table.css';

class WidgetListVerticalTable extends Component {

    constructor (props) 
    {
        super(props);

        this.state = {
            pageSize: props.pageSize || 9,
            type:props.type
        }
    }

    componentWillReceiveProps( nextProps )
    {
        this.setState({pageSize:nextProps.pageSize});
    }

    changeType = ( type ) => {

        this.setState({type:type});
    }

    notify = ( item, type) => {

        if( this.props.notify )
        {
            this.props.notify(type, item);
        }
    }

    pageChange = (page, pageSize) => {

        this.setState({page:page, pageSize:pageSize});

        if( this.props.pageTurning )
        {
            this.props.pageTurning(page, pageSize);
        }
    }

    render() 
    {
        const { pageSize, type="single" } = this.state;

        const {data=[], page=1, total=0, loading=true } = this.props;

        return (
            <div className="sf-list-vertical-table sd-list-vertical-table sg-list-vertical-table">
                <div className="sf-list-vertical-table-content">
                {
                    loading ? 
                    <>
                        <Spin />;
                    </>
                    :
                    <>
                    {
                        data.map((item, index) => {
                            return (
                                <div key={item.id + index} className="sf-list-vertical-table-item">
                                    <div className="sf-list-vertical-table-item-icon">
                                        {item.img ? <img src={require('./../img' + item.img)} alt=""></img> : <img src={require('./../img/widget/evaluation.png')} alt=""></img>}
                                    </div>
                                    <div className="sf-list-vertical-table-item-bottom">
                                        <div className="sf-list-vertical-table-item-title">
                                            <div>{item.title}</div>
                                            <div className="sf-list-vertical-table-duration">{item.duration}</div>
                                        </div>
                                        <div className="sf-list-vertical-table-item-description">
                                            <Tooltip title={item.description}>
                                                {item.description}
                                            </Tooltip >
                                        </div>
                                        <div className="sf-list-vertical-table-item-operation">
                                            <div className="sf-list-vertical-table-item-operation-item">
                                                <img src={require('./../img/widget/user.png')} alt="" />
                                                <span>{item.completed}</span>
                                            </div>
                                            <div className="sf-list-vertical-table-item-operation-item">
                                                <div className="sf-list-vertical-table-favor">
                                                {
                                                    item.isfavor ? <img src={require('./../img/widget/favor-select.png')} alt="" /> : <img src={require('./../img/widget/favor.png')} alt="" />
                                                }
                                                <span>{item.thumbUps}</span>
                                                </div>
                                                
                                                <div>
                                                    <Button className="sf-list-vertical-table-item-operation-button" onClick={ () => { this.notify(item, "click") }}>进入测评</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                    </>
                }
                
                </div>

                <div className="sf-list-vertical-table-page">
                    <WidgetPagination 
                        page={page} 
                        total={total} 
                        pageSize={pageSize}
                        pageSizeOptions={[10, 20, 50, 100]}
                        pageChange={this.pageChange} 
                    />
                </div>
            </div>
        )
    }
}

export default WidgetListVerticalTable;